var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPinSea(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2459 3C13.1604 3 15.492 5.37039 15.492 8.24616C15.492 10.8886 14.4817 11.627 12.8496 14.0752L10.246 18L7.64242 14.0752C6.01029 11.627 5 10.8888 5 8.24616C5 5.37049 7.37039 3 10.2462 3H10.2459ZM10.2459 5.72004C11.6448 5.72004 12.7718 6.847 12.7718 8.24591C12.7718 9.64483 11.6448 10.7718 10.2459 10.7718C8.84698 10.7718 7.72001 9.64483 7.72001 8.24591C7.72001 6.847 8.84698 5.72004 10.2459 5.72004Z",
    fill: "#76CCCC"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinSea);
export default __webpack_public_path__ + "static/media/PinSea.f72c01107e53dceb1141299be5476926.svg";
export { ForwardRef as ReactComponent };